import { useLang } from 'hooks/lang';

import { FullProjectIssue } from 'entities';

import { Column, DatePicker, Modal, LabeledTextarea, LabeledInput, Label } from 'components/Blocks';

import { CreateIssueButton } from './ExecuteButton';
import { Executors } from './Executors';
import { Actions } from './Actions';
import { IssueType } from './Type';
import { Sales } from './Sales';

import { useFormControl } from 'hooks';

import { IssueCreationForm } from './types';

interface CreateModalProps {
  children?: never;
  open: boolean;
  close: () => void;
  registerNewIssue: (newIssue: FullProjectIssue) => void;
}

export function CreateModal({ close, open, registerNewIssue }: CreateModalProps) {
  const { t } = useLang();

  const { state, handleChange, dispatch, resetDefault } = useFormControl<IssueCreationForm>({
    name: '',
    description: '',
    type: '',
    subType: '',
    other: null,
    actions: [],
    executors: [],
    sales: [],
    startDate: undefined,
  });

  const resetModal = (): void => {
    close();
    setInterval(resetDefault, 500); // visual glitch prevention
  };

  return (
    <Modal
      isOpen={open}
      close={close}
      width="min(90vw, 850px)"
      title={t('register-issue')}
      gap="6"
      className="overflow-y-auto"
    >
      <LabeledInput value={state.name} onChange={handleChange} name="name" label={t('name')} />

      <LabeledTextarea
        value={state.description}
        onChange={handleChange}
        name="description"
        label={t('description') as string}
      />

      <IssueType state={state} dispatch={dispatch} />

      <Actions state={state} dispatch={dispatch} />

      <Executors state={state} dispatch={dispatch} />

      <Sales state={state} dispatch={dispatch} />

      <Column gap="2">
        <Label>{t('start-date')}</Label>

        <DatePicker
          onSelect={(startDate) => dispatch({ startDate })}
          selected={state.startDate}
          disableFuture
        />
      </Column>

      <CreateIssueButton state={state} close={resetModal} registerNewIssue={registerNewIssue} />
    </Modal>
  );
}
